import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Link, useNavigate } from 'react-router-dom';
import { Nav, Tab, Button } from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import CoachProfile from 'components/Common/Coaches/Views/Profile/Index';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

export default function Index({ showSteps, onNextStep, showPrevButton }) {
  const navigate = useNavigate();

  const { dispatch, actions, state } = useContext();

  const [loading, setLoading] = useState(false);
  const [coaches, setCoaches] = useState(null);
  const [selectedCoach, setSelectedCoach] = useState(state.program.attributes.coach);

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  useEffect(() => {
    axios
      .get(routes.api.members.recommendedCoaches(state.program.id))
      .then((resp) => {
        setCoaches(resp.data.data);
        setSelectedCoach(resp.data.data[0]);
      });
  }, []);

  const selectCoach = () => {
    setLoading(true);

    actions.updateCoach(dispatch, state.program.id, selectedCoach.id, () => {
      setLoading(false);
      if (onNextStep !== undefined) {
        onNextStep();
      } else {
        navigate(routes.members.programs.new.confirm(state.program.id));
      }
    });
  };

  return (
    <>
      {showSteps && (
      <StepTab
        total={state.program.attributes.is_first_assessment_needed ? 5 : 4}
        current={state.program.attributes.is_first_assessment_needed ? 4 : 3}
      />
      )}

      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Select Coach</h1>

          <p>
            LeggUP&apos;s diverse network allows you access to certified expert coaches.
            Our AI algorithm enhances coach recommendations, so that you can select the coach that best fits your needs.
          </p>
        </section>

        {coaches === null || selectedCoach === null ? (
          <section>
            <LoadingPlaceholder text="Loading..." />
          </section>
        ) : (
          <>
            <Tab.Container
              id="select-coach"
              defaultActiveKey={`coach-${selectedCoach.id}`}
            >
              <Nav fill justify variant="tabs" className="d-flex">
                {coaches.map((coach, index) => (
                  <Nav.Item key={coach.id}>
                    <Nav.Link
                      eventKey={`coach-${coach.id}`}
                      onClick={() => setSelectedCoach(coach)}
                    >
                      <img src={coach.attributes.avatar_url} alt="" width="44" height="44" />
                      <div className="d-none d-lg-inline">
                        {coach.attributes.full_name}
                      </div>

                      {index === 0 && (
                        <span className="best-match-label">Best Match</span>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>

              <Tab.Content>
                {coaches.map((coach) => (
                  <Tab.Pane key={coach.id} eventKey={`coach-${coach.id}`} className="px-sm-4 px-xxl-5">
                    <CoachProfile coach={coach} />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>

            <footer className={`d-flex ${showPrevButton ? 'justify-content-between' : 'justify-content-end'} `}>
              {showPrevButton
              && (
              <Link
                to={routes.members.programs.new.myPreferences(state.program.id)}
                className={`btn btn-outline-primary ${loading && 'disabled'}`}
              >
                Previous
              </Link>
              )}

              <Button
                onClick={() => selectCoach()}
                disabled={loading}
              >
                {loading && <LoadingPlaceholder placement="inline" text=" " />}
                Next
              </Button>
            </footer>
          </>
        )}
      </div>

    </>
  );
}

Index.propTypes = {
  showSteps: PropTypes.bool,
  onNextStep: PropTypes.func,
  showPrevButton: PropTypes.bool,
};

Index.defaultProps = {
  showSteps: true,
  onNextStep: undefined,
  showPrevButton: true,
};
